module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.3a6839d0.svg";